<template><div><h1>VUX V2.1.0 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] support array type of menu #950 @wuchuguang</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul></ul>
<h2><a href="/en/components/icon.html">Icon</a></h2>
<ul></ul>
<h2><a href="/en/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/msg.html">Msg</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul></ul>
<h2><a href="/en/components/view-box.html">ViewBox</a></h2>
<ul></ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul></ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] fix `transition` binding</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[feature] upgrade `WeUI`</li>
<li>[fix] fix `label` styles donot conform with `group` settings</li>
<li>[feature] support prop:`align`</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-73.vue?601f20c3